import { LibraryItem } from '../../pages/library/components/library-list/types';

/**
 * "Employee Policy and Procedures - All in One for Acknowledgement"
 * Business Kitz library item: /admin/api/documentlibrary/131/
 */
export const EMPLOYEE_MANUAL_LIBRARY_ID = 131;
export const EMPLOYEE_MANUAL_TEMPLATE_NAME =
  'Employee Policy and Procedures - All in One for Acknowledgement';

export const EMPLOYEE_MANUAL_INSTRUCTION_STEPS = [
  'chooseEmployee',
  'fillFields',
  'removePolicies',
  'checkLeavePolicy',
  'sendForSigning',
] as const;

const normalizeName = (name?: string | null) =>
  (name ?? '')
    .toLowerCase()
    .replace(/[\u2013\u2014]/g, '-')
    .replace(/\s+/g, ' ')
    .trim();

/**
 * True for the Employee Policy and Procedures manual, whether it is opened from the
 * Business Kitz library (matched by its library id) or from My Templates. A copy in
 * My Templates keeps no link to its library item, so it is matched by name: copies
 * are saved as "<library name> - <date> <time>" by default.
 */
export const isEmployeeManualTemplate = (libraryItem?: LibraryItem | null): boolean => {
  if (!libraryItem) return false;
  const isOwnTemplate = 'document_upload' in libraryItem;
  if (!isOwnTemplate) {
    return libraryItem.id === EMPLOYEE_MANUAL_LIBRARY_ID;
  }
  return normalizeName(libraryItem.name).includes(normalizeName(EMPLOYEE_MANUAL_TEMPLATE_NAME));
};
